// extracted by mini-css-extract-plugin
export default {"shell":"pagination_shell__c6Llq"};